import Vue from "vue";
import store from "store";

import skyFonts from "sky-fonts";

import "sky-overlay";
import "sky-search";
import "sky-form-editor";
import "sky-reveal";
import "sky-accordion";
import "sky-gallery";
import "sky-lightbox";
import "sky-news";
import "sky-crop";
import "sky-video";
import "sky-swiper";
import "sky-svg";
import "sky-sticky";
import "sky-scroll";
import "sky-mailchimp";
import "sky-input-file";
import "sky-sharethis";
import "cookie-blocker";
import "ro-folder-view";

import "sky-mailchimp/sky-approve";

// import 'ro-presentation';
import "ro-header";
import "ro-read-more";
import "ro-nav";
import "ro-person-search";
import "ro-copy";
import "ro-sign-up";

new Vue({
    el: "[sky-app]",
    store,
});

skyFonts("fonts.com", "45bdc2ff-25cc-4a04-a786-4f7cfde64068");



// WEBPACK FOOTER //
// ./scripts/app.js